<template>
  <b-card class="mb-4" no-header>
    <b-row>
      <b-col cols="12">
        <div class="d-flex mb-3">
          <b-button-group class="add-button-group">
            <b-btn variant="primary" to="/stocks/create">Tambah Data</b-btn>
          </b-button-group>
          <div class="ml-auto" v-if="$store.getters['account/accountData'].role === Roles.ADMIN">
            <b-form-checkbox id="checkbox-trash" v-model="filter.with_trash" name="checkbox-trash" :value="1" :unchecked-value="null">
            Lihat Data Terhapus
            </b-form-checkbox>
          </div>
          <!-- <b-button-group class="add-button-group ml-auto">
            <b-btn variant="success" type="button" @click.prevent="doExport"><font-awesome-icon icon="file-excel"/> Ekspor</b-btn>
          </b-button-group> -->
        </div>
      </b-col>
      <b-col cols="12" class="mb-4">
        <b-form @submit.prevent="doFilter">
          <b-row class="filter-row">
            <b-col cols="12" md="6">
              <form-group-input ref="filter-stock_barcode" @keyup="filterWithKeyboard" type="text" placeholder="" :need-label="true" label="barcode" v-model="filter.stock_barcode" id="filter-stock_barcode" />
            </b-col>
            <b-col cols="12" md="6">
              <form-group-input ref="filter-nama" @keyup="filterWithKeyboard" type="text" placeholder="" :need-label="true" label="nama" v-model="filter.nama" id="filter-nama" />
            </b-col>
            <b-col cols="12" md="4">
              <form-group-input ref="filter-kadar" @keyup="filterWithKeyboard" type="text" placeholder="" :need-label="true" label="kadar" v-model="filter.kadar" id="filter-kadar" />
            </b-col>
            <b-col cols="12" md="4">
              <form-group-input type="enum" label="jenis" :need-label="true" :options="jenisOptions" v-model="filter.jenis_barang" id="filter-jenis_barang" />
            </b-col>
            <b-col cols="12" md="4">
              <form-group-input type="enum" label="status" :need-label="true" :options="approvalStatusOptions" v-model="filter.approval_status" id="filter-approval_status" />
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="12" md="6">
              <b-form-checkbox id="checkbox-available_only" v-model="filter.available_only" name="checkbox-available_only" :value="1" :unchecked-value="null">
                Hanya Stok Tersedia
              </b-form-checkbox>
            </b-col>
            <b-col cols="12" md="6" class="text-right"></b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
    <paginated-table ref="dataTable" :delete-reason="false" :can-delete="false" :can-edit="false" :can-show="!filter.with_trash" :data-url="apiUrl.stock" :data-columns="columns" :dataParams="dataParams" :defaultDataParams="this.filter">
      <template slot="content_approval_status" slot-scope="defaultSlotScope">
        <b-badge :variant="statusVariant(defaultSlotScope.colData.approval_status)">{{ statusLabel(defaultSlotScope.colData.approval_status) }}</b-badge>
      </template>
      <template slot="content_berat" slot-scope="defaultSlotScope">
        {{ formatWeight(defaultSlotScope.colData.berat) }}
      </template>
      <template slot="content_stock_balance" slot-scope="defaultSlotScope">
        {{ formatBalance(defaultSlotScope.colData) }}
      </template>
      <template slot="content_nama" slot-scope="defaultSlotScope">
        <router-link v-if="!filter.with_trash" class="text-dark  text-left" :to="'/stocks/' + defaultSlotScope.colData.id" style="text-decoration: underline;">{{defaultSlotScope.colData.nama}}</router-link>
        <span v-else>{{defaultSlotScope.colData.nama}}</span><a href="#" copyBarcode class="bg-secondary text-light" style="border-radius: 4px;margin-left: 5px;display: inline-block; padding: 3px 5px;" title="Copy barcode" @click.prevent="copyBarcode(defaultSlotScope.colData.stock_barcode)">
          <font-awesome-icon icon="barcode"/>
        </a>
      </template>
      <template slot="actionButtons" slot-scope="defaultSlotScope">
        <b-button v-if="!filter.with_trash" variant="primary" size="sm" :to="'/stocks/' + defaultSlotScope.colData.id" class="mb-0 text-center" title="Detail stok">
          <font-awesome-icon icon="info"/>
        </b-button>
        <b-button v-else variant="primary" size="sm" class="mb-0 text-center" title="Pulihkan stok" @click.stop.prevent="restoreStock(defaultSlotScope.colData.id)">
          <font-awesome-icon icon="sync-alt"/>
        </b-button>
      </template>
    </paginated-table>
      <input type="text" :id="`copy-barcode-text`" style="z-index: -1122; position: absolute; opacity: 0;">
  </b-card>
</template>

<script>
// import { objectToOptions } from '@/_helpers'
import paginatedTable from '@/components/PaginatedTable.vue'
import formGroupInput from '@/components/FormGroupInput.vue'
import Stock from '@/models/Stock.js'
import { Roles, debounce } from '@/_helpers'

const stockModel = new Stock()

export default {
  components: {
    formGroupInput,
    paginatedTable
  },
  data () {
    return {
      Roles: Roles,
      isLoading: false,
      totalPromiseAreaCount: 0,
      apiUrl: {
        stock: stockModel.endpoint
      },
      columns: [
        {
          prop: 'nama',
          label: 'Nama',
          deletedDetailHere: true,
          sortable: true,
          resizable: true,
          minWidth: 250,
          wrapInLink: true,
        },
        {
          prop: 'berat',
          label: 'Berat',
          resizable: true,
          sortable: true,
          minWidth: 90,
          align: 'left',
        },
        {
          prop: 'kadar',
          label: 'Kadar',
          resizable: true,
          sortable: true,
          minWidth: 100,
        },
        {
          prop: 'jenis_barang',
          label: 'Jenis',
          resizable: true,
          minWidth: 100,
        },
        {
          prop: 'approval_status',
          label: 'Status',
          resizable: true,
          minWidth: 110,
          align: 'center',
        },
        {
          prop: 'stock_balance',
          label: 'Saldo Stok',
          resizable: true,
          sortable: true,
          minWidth: 110,
          align: 'center',
        },
        {
          prop: 'harga_jual',
          label: 'Harga Jual',
          resizable: true,
          sortable: true,
          needCurrency: true,
          minWidth: 125,
          align: 'right',
        },
      ],
      filter: {
        with_trash: typeof this.$route.query.with_trash !== 'undefined' ? parseInt(this.$route.query.with_trash) : null,
        nama: typeof this.$route.query.nama !== 'undefined' ? this.$route.query.nama : null,
        kadar: typeof this.$route.query.kadar !== 'undefined' ? this.$route.query.kadar : null,
        available_only: typeof this.$route.query.available_only !== 'undefined' ? parseInt(this.$route.query.available_only) : null,
        stock_barcode: typeof this.$route.query.stock_barcode !== 'undefined' ? this.$route.query.stock_barcode : null,
        jenis_barang: typeof this.$route.query.jenis_barang !== 'undefined' ? this.$route.query.jenis_barang : null,
        kadar_kosong: typeof this.$route.query.kadar_kosong !== 'undefined' ? parseInt(this.$route.query.kadar_kosong) : null,
        approval_status: typeof this.$route.query.approval_status !== 'undefined' ? this.$route.query.approval_status : null,
      },
      dataParams: ['nama', 'with_trash', 'stock_barcode', 'available_only', 'kadar', 'kadar_kosong', 'jenis_barang', 'approval_status'],
      jenisOptions: [
        { value: null, text: 'Semua Jenis' },
        { value: 'emas', text: 'Emas' },
        { value: 'berlian', text: 'Berlian' },
        { value: 'perhiasan', text: 'Perhiasan' }
      ],
      approvalStatusOptions: [
        { value: null, text: 'Semua Status' },
        { value: 'draft', text: 'Draft' },
        { value: 'on_review', text: 'On Review' },
        { value: 'approved', text: 'Disetujui' },
        { value: 'returned', text: 'Dikembalikan' },
        { value: 'rejected', text: 'Ditolak' }
      ]
    }
  },
  beforeMount () {
    this.$router.push({query: {...this.$route.query}}).catch(() => {})
  },
  watch: {
    'filter.with_trash': function () {
      this.filter.available_only = null
      this.doFilter()
    },
    'filter.available_only': function () {
      this.doFilter()
    },
    'filter.approval_status': function () {
      this.doFilter()
    }
  },
  methods: {
    statusLabel (status) {
      return { draft: 'Draft', on_review: 'On Review', approved: 'Disetujui', returned: 'Dikembalikan', rejected: 'Ditolak' }[status] || status
    },
    statusVariant (status) {
      return { draft: 'secondary', on_review: 'warning', approved: 'success', returned: 'warning', rejected: 'danger' }[status] || 'secondary'
    },
    formatWeight (weight) {
      return Number(weight || 0).toLocaleString('id-ID', { minimumFractionDigits: 3, maximumFractionDigits: 3 }) + ' gram'
    },
    formatBalance (stock) {
      const amount = Number(stock.stock_balance || 0)
      const isGram = stock.inventory_unit === 'gram'
      const formatted = isGram
        ? amount.toLocaleString('id-ID', { minimumFractionDigits: 3, maximumFractionDigits: 3 })
        : amount.toLocaleString('id-ID', { maximumFractionDigits: 0 })
      const unitLabel = isGram ? 'gram' : 'buah'
      return formatted + ' ' + unitLabel
    },
    copyBarcode (barcodeText) {
      let copyText = document.getElementById("copy-barcode-text");
      copyText.value = barcodeText
      // Select the text field
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices

      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.value);
      this.$store.dispatch('notification/success', 'Barcode berhasil di copy.')
    },
    filterWithKeyboard() {
      this.debounceFilter(this);
    },
    debounceFilter: debounce((vm) => {
      vm.doFilter()
    }, 350),
    clearForm () {
      this.$nextTick(() => {
        this.filter = {
          nama: null,
          kadar: null,
          with_trash: null,
          stock_barcode: null,
          approval_status: null,
        }
        setTimeout(() => {
          this.doFilter()
        }, 100)
      })
    },
    doFilter () {
      this.$refs.dataTable.doFilter(this.filter)
    },
    async restoreStock (id) {
      try {
        await stockModel.restore(id)
        this.$store.dispatch('notification/success', 'Stok berhasil dipulihkan.')
        this.$refs.dataTable.getDataTable()
      } catch (e) {
        this.$store.dispatch('notification/error', e)
      }
    },
    doExport () {
      if (this.isLoading) {
        return false;
      }
      this.isLoading = true;
      const filterArray = [];
      Object.keys(this.filter).forEach(key => {
        if (this.filter[key]) {
          filterArray.push(key + "=" + this.filter[key]);
        }
      });
      filterArray.push('csv=1');

      this.$http.get(stockModel.getEndpoint() + "?" + filterArray.join("&")).then(response => {
        const a = document.createElement("a");

        const blob = new Blob([response.data], {type: "octet/stream"});
        a.href = window.URL.createObjectURL(blob);

        a.download = "data_admin.csv";
        a.click();
        this.isLoading = false;
      }).catch(error => {
        this.$store.dispatch('notification/error', error)
        this.isLoading = false;
      })
    }
  }
}
</script>
